import RootLayout from "@/layouts/RootLayout";

import ErrorPage from "@/pages/ErrorPage.jsx";

import Dashboard from "@/pages/Dashboard.jsx";

import Account from "@/pages/Account/Account";
import BankPage from '@/pages/BankDetailsPage/BankPage.jsx';
import DummyPage from '@/pages/DummyPage.jsx'; //TODO: To remove once redirection is set up
import Profile from "@/pages/Account/Profile/Profile";

import store from "@/store/store";

import {
  setMainHeaderVisibilityAction,
  setSubHeaderTitleAction,
  setNavBarVisibilityAction,
} from "@/store/global";

const rawRoutes = [
  {
    element: <RootLayout />,
    errorElement: <ErrorPage />,
    handle: {
      title: "Torus Dashboard",
      hasMainHeader: true,
      subHeaderTitle: "",
      hasNavBar: true,
    },
    children: [
      {
        index: true,
        element: <Dashboard />,
        handle: {
          title: "Torus Dashboard",
          hasTickerTape: true,
          hasMainHeader: true,
          hasNavBar: true
        },
      },
      {
        path: "account",
        element: <Account />,
        handle: {
          title: "Torus Account",
          hasMainHeader: true,
          hasTickerTape: true,
        },
        children: [
          {
            index: true,
            element: <Profile />,
            handle: {
              title: "Torus Profile",
              hasMainHeader: true,
            },
          },
          {
            path: "profile",
            element: <Profile />,
            handle: {
              title: "Torus Profile",
              hasMainHeader: true,
            },
          },
        ],
      },
      {
        path: "bank",
        element: <BankPage />,
        handle: {
          hasMainHeader: true,
        },
      },
      {
        path: "stocks",
        element: <DummyPage />,
        
      },
      {
        path: "mutual-funds",
        element: <DummyPage />,
      },
      {
        path: "*",
        element: <ErrorPage />,
      },
    ],
  },
];

const getLoader =
  (handle = {}) =>
  () => {
    store.dispatch(setMainHeaderVisibilityAction(handle.hasMainHeader));
    store.dispatch(setSubHeaderTitleAction(handle.subHeaderTitle));
    store.dispatch(setNavBarVisibilityAction(!!handle.hasNavBar));

    document.title = handle.title || "Torus | Dashboard";
    window.scrollTo(0, 0);

    return null;
  };

const routeTransformer = (rawRoute) => {
  const route = {};
  route.index = rawRoute.index;
  route.path = rawRoute.path;
  route.element = rawRoute.element;
  route.errorElement = rawRoute.errorElement;
  route.handle = rawRoute.handle;
  route.loader = getLoader(rawRoute.handle);
  route.children = rawRoute.children?.map(routeTransformer);
  // TODO: Add Breadcrumbs
  return route;
};

export const routes = rawRoutes.map(routeTransformer);
